import Request from 'utils/request';
import config from 'config/Config';

export default class {
  static workAuthBind(params) {
    return Request({
      url: `user/login/authBind`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  static xiangMaiSilent(data) {
    return Request({
      url: `user/login/xiangMaiSilent`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/WechatAuth/SelectBindCardCode/SelectBindCardCodeServ.js